<template>
	<div></div>
</template>

<script>
	function enter(vm, to) {
		vm.$parent.$emit('enterState', to.name, to.params);
	}

	export default {
		name: "sheet-expenses-state",
		beforeRouteEnter(to, from, next) {
			next((vm) => {
				enter(vm, to);
			});
		},
		beforeRouteUpdate (to, from, next) {
			enter(this, to);
			next();
		},
		beforeRouteLeave(to, from, next) {
			this.$parent.$emit('exitState', from.name);
			next();
		}
	}
</script>



// WEBPACK FOOTER //
// src/ui/sheet-expenses-state.vue